<template>
    <div class="container-fluid">
        <loading
            :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="true"
            color="#007bff"
            background-color="#ffffff"
        >
        </loading>
		<div class="row d-flex justify-content-center mt-2">
            <div class="col-12">
    			<div class="alert alert-primary h4 text-center">
    	          	<linkto :link="'/'"/>
    	          	Érdeklődő keresés
    	      	</div>
            </div>
            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="s.aktiv">
                        <option :value="0">NEM Aktív</option>
                        <option :value="1">Aktív</option>
                        <option :value="2">Mindkettő</option>
                    </select>
                    <label>Érdeklődő státusz</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.nev">
                    <label>Név (elég a szótöredék pl: `Ková` vagy `éter`)</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.varos">
                    <label>Város (elég a szótöredék pl: `szege` vagy `háza`)</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.cim">
                    <label>Cím (régi egyben írt, pl: Kossuth utca 28.)</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.cim_utca">
                    <label>Közterület típusa, pl utca tér</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.tel">
                    <label>Telefon</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.cim_hsz">
                    <label>Házszám</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="s.cim_ea">
                    <label>Emelet / ajtó</label>
                </div>
            </div>
            <div class="col-6 col-lg-2">
                <label>Rögzítette</label>
                <select
                    class="form-control"
                    v-model="s.user"
                >
                    <option value="">Mindenki</option>
                    <option
                        v-for="(v,k) in szolg"
                        :key="k"
                        :value="v.megjegyzes"
                        v-show="v.aktiv ==1"
                    >
                        {{ v.megjegyzes }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row d-flex justify-content-center mt-2 mb-2">
            <div class="col-12 col-lg-2 text-center">
                <span class="h6">Régió</span>
                <div class="input-group">
                    <input type="number" class="form-control text-center" v-model="s.regio_kezd"></input>
                    <input type="number" class="form-control text-center" v-model="s.regio_veg"></input>
                </div>
            </div>
            <div class="col-12 col-lg-6 text-center">
                <button
                  class="btn btn-outline-primary m-1"
                  @click.prevent="regio_set(v.start,v.end)"
                  v-for="(v,k) in regioButtons"
                  :key="k"
                >
                  {{v.start}}-{{v.end}}
                </button>
            </div>
            <div class="col-6 col-lg-2 text-center">
                <span>Rögzítve -tól</span>
                <date-picker
                    class="text-center"
                    v-model="s.datum_tol"
                    :config="date_options"
                />
            </div>
            <div class="col-6 col-lg-2 text-center">
                <span>Rögzítve -ig</span>
                <date-picker
                    class="text-center"
                    v-model="s.datum_ig"
                    :config="date_options"
                />
            </div>
        </div>
        <div class="row d-flex justify-content-center mt-2 mb-3">
            <div class="col-12 text-center">
                <button
                    class="btn btn-lg btn-primary m-1"
                    @click="load"
                >
                    Keresés
                </button>
                <button
                	class="btn btn-lg btn-outline-success m-1"
                	disabled
                	v-if="list.length>0"
                >
                    {{ list.length }} érdeklődő
                </button>
                <button
                    class="btn btn-lg btn-primary m-1"
                    @click="downloadxls"
                    v-if="list.length>0"
                >
                    Letöltés
                </button>
            </div>
        </div>
        <div class="table-responsive" v-if="list.length>0">
      		<table class="table table-striped">
            	<thead>
                    <th>Státusz</th>
                    <th>Név</th>
                    <th>Rögzítette</th>
                    <th>Dátum</th>
            		<th>Régió</th>
            		<th>Város</th>
                    <th>Cím</th>
                    <th>Telefon</th>
            		<th>E-mail</th>
            		<th>#</th>
            	</thead>
            	<tbody>
            		<tr
            			v-for="(v,k) in list"
            			:key="k"
                        v-tooltip="tooltip(v)"
            		>
                        <td>
                            <i class="fas fa-check text-success" v-if="v.aktiv == 1"></i>
                            <i class="fas fa-times text-danger" v-else></i>
                        </td>
                		<td>{{v.nev}}</td>
                        <td>{{v.user}}</td>
                        <td>{{v.datum}}</td>
                        <td>{{v.regio}}</td>
                		<td>{{v.varos}}</td>
                        <td>{{v.cim}}</td>
                        <td>{{v.telm}}</td>
        				<td>{{v.email}}</td>
        				<td>
        					<router-link
				                :to="`/inquiring/edit/${v.id}`" target="_blank"
				            >
				                <button class="btn btn-outline-primary">
				                    Módosít
				                </button>
				            </router-link>
				        </td>
        			</tr>
        		</tbody>
            </table>
        </div>
    </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
export default {
    data() {
	    return {
  			s: {
				inquiring: 1,
				aktiv: 2,
				nev: '',
				varos: '',
				cim: '',
				cim_utca: '',
				cim_hsz: '',
				cim_ea: '',
				tel: '',
                regio_kezd: null,
                regio_veg: null,
                datum_tol: this.$moment().subtract(2,'y').format('YYYY-MM-DD'),
                datum_ig: this.$moment().format('YYYY-MM-DD'),
                user: ''
            },
            list: [],
            szolg: []
	    }
    },

    mounted() {
        this.$Progress.start()
        this.req.post('/others')
            .then(res => {
                this.szolg = res.data.szolg
                this.$Progress.finish()
            })
            .catch(err => {
                this.$Progress.fail()
            })
    },

    methods: {
		load(){
          	this.$Progress.start()
          	this.isLoading = true
          	this.req.post('/inquiring/search', {
              	search: this.s
          	})
              	.then(res => {
                  	this.list = res.data.list
                  	this.$Progress.finish()
                  	this.isLoading = false
              	})
              	.catch(err => {
                	console.log(err)
                	this.$Progress.fail()
                	this.isLoading = false
              	})
      	},

      	tooltip(x) {
          	let v = Vue.filter('tel')(x.telv)
          	let m = Vue.filter('tel')(x.telm)
          	let tel =  `${v}${v&&m?' <br> ':''}${m} <br><br>`

          	let email = x.email
          	if(x.email.length > 0 && x.email) email = email + '<br><br>'

          	return `${tel}${email}${x.megj!=null?x.megj:''}`
      	},

        regio_set(from,to) {
            this.s.regio_kezd = from
            this.s.regio_veg = to
        },

        downloadxls() {
            this.$Progress.start()
            this.req.post('/inquiring/search/download', {
                search: this.s
            }, { responseType: 'blob' } )
                .then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', `erdeklodo_lista_${this.$moment().format('YYYY-MM-DD')}.xls`)
                    document.body.appendChild(link)
                    link.click()
                    this.$Progress.finish()
                })
                .catch(err => {
                    console.log(err)
                    this.$Progress.fail()
                })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/inquiring/list.vue